import Image from 'next/image';
import ImageLogoBtcusd from '@/assets/images/image-logo-btcusd.png';

export interface Props {}

export default function LogoBtcusd({}: Props) {
  return <Image alt="" src={ImageLogoBtcusd} />;
}
